import { CommonContext } from '@repo-level/core-front';
import { ANJOUAN_COUNTRIES } from 'modules/policies/constants';
import { useContext, useEffect } from 'react';

const SEAL_ID = '360ec5fc-50c7-4f3e-bb97-56aad32cefd3';
const SCRIPT_SRC = `https://${SEAL_ID}.seals.dlagglobal.com/dlag-seal.js`;

declare global {
  interface Window {
    dlag_360ec5fc_50c7_4f3e_bb97_56aad32cefd3?: {
      init: () => void;
    };
  }
}

export const TobiqueSeal = () => {
  const { currentIp } = useContext(CommonContext);
  const isTobiqueCountry = !ANJOUAN_COUNTRIES.includes(
    currentIp?.countryCode ?? ''
  );

  useEffect(() => {
    if (!isTobiqueCountry) return;

    const initSeal = () => {
      window.dlag_360ec5fc_50c7_4f3e_bb97_56aad32cefd3?.init();
    };

    if (document.querySelector(`script[src="${SCRIPT_SRC}"]`)) {
      initSeal();
      return;
    }

    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = SCRIPT_SRC;
    script.onload = initSeal;
    document.head.appendChild(script);
  }, [isTobiqueCountry]);

  if (!isTobiqueCountry) return null;

  return (
    <div
      data-dlag-image-size="128"
      data-dlag-image-type="basic-light-small"
      data-dlag-seal-id={SEAL_ID}
      id={`dlag-${SEAL_ID}`}
    />
  );
};
